import { Box, styled, Typography } from "@mui/material";
import { FC } from "react";
import MappedIcon from "~/icons/Mapped";


const color = '#00B2FF'

const EncryptionRuleLabelRoot = styled(Box)(({theme}) => ({
  height: 26, 
  position: 'relative',

  '& div.icon': {
    borderRadius: '50%',
    backgroundColor: color,
    width: 24,
    height: 24,
    padding: '1px',

    '& > svg': {
      color: theme.palette.background.default, 
      backgroundColor: color, 
      clipPath: 'circle(50%)',
    },
  },
  '& div.text': {
    position: 'absolute',
    top: 0,
    left: 0,
    height: 24,
    paddingLeft: '30px',
    paddingRight: '6px',
    
    borderRadius: '13px', 
    border: `1px solid ${color}`,

    '& > .MuiTypography-root': {
      color: color,
      lineHeight: '24px',
      whiteSpace: 'nowrap',
    },
  },
}))

interface EncryptionRuleLabelProps {
  text: string,
}

const EncryptionRuleLabel: FC<EncryptionRuleLabelProps> = ({
  text,
}) => {
  return (
    <EncryptionRuleLabelRoot>
      <Box className="icon">
        <MappedIcon />
      </Box>
      <Box className="text">
        <Typography variant="body2">{text}</Typography>
      </Box>
    </EncryptionRuleLabelRoot>
  )
}

export default EncryptionRuleLabel;
